import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for createConfiguration mutation
 */
export interface CreateConfigVariables {
  image_data?: string;
  optionKey?: string;
  optionValue?: string;
}

/**
 * Created configuration structure
 */
export interface CreatedConfiguration {
  id: string;
  optionKey: string;
  optionValue: string | null;
  optionScope: string;
  imageData: string | null;
}

/**
 * Create configuration payload structure
 */
export interface CreateConfigurationPayload {
  configuration: CreatedConfiguration;
}

/**
 * Response structure for createConfiguration mutation
 */
export interface CreateConfigResponse {
  createConfiguration: CreateConfigurationPayload;
}

const createConfig: DocumentNode = gql`
  mutation configuration_create($image_data: String, $optionKey: String, $optionValue: String) {
    createConfiguration(optionKey: $optionKey, imageData: $image_data, optionValue: $optionValue) {
      configuration {
        id
        optionKey
        optionValue
        optionScope
        imageData
      }
    }
  }
`;

export default createConfig;
